const Contact = require('@/lib/Contacts/Contact');
const { toDate, toInt } = require('@/functions/transform');

/**
 * @constructor
 */
const Redemption = function () {
    this.contact = null;
    this.ID = null;
    this.method = null;
    this.qty = 0;
    this.triggeredAt = null;
    this.type = null;
};

Redemption.prototype = {
    getHydrationMap() {
        return {
            contact: {
                model: Contact,
            },
            ID: {
                field: ['ID', 'redemptionID'],
                transform: toInt,
            },
            method: {},
            qty: toInt,
            triggeredAt: toDate,
        };
    },

    afterHydration() {
        this.type = this.getType();
    },

    getType() {
        return this.qty < 0 ? 'UNREDEMPTION' : 'REDEMPTION';
    },

    getMemberName() {
        return this.contact ? this.contact.getFullName() : '(Unknown)';
    },
};

module.exports = Redemption;
